import { type Filter, type LocationArea } from '@kijiji/generated/graphql-types'
import { type TFunction } from 'i18next'

import { QUICK_FILTER_LABEL_CONFIG } from '@/features/filters/constants/quickFilterLabelConfig'

export type QuickFilterLabelOverrideProps = (filter: Filter) => string

export const getQuickFilterLabel = (
  filter: Filter,
  t: TFunction,
  area?: LocationArea | null
): string | undefined => {
  const { name, label } = filter

  const filtersConfig = QUICK_FILTER_LABEL_CONFIG[name]
  const labelOverride = filtersConfig?.labelOverride ?? null

  return labelOverride ? labelOverride(filter, t, area) : label
}
